import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import UserRoles from './UserRoles'
import NewUserFormContainer from './NewUser/new_user_form_container'

function getModalStyle() {
    return {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        maxHeight: '90vh',
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 2, 2),
        '&:focus': {
            outline: 'none'
        },
        '&::-webkit-scrollbar': {
            width: '8px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '4px'
        }
    },
}));

export default function SimpleModal({ closeModal, modalTitle, currentRole, modifyRole, centerTitle, setUserCreated}) {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    
    return (
        <Modal
            open={true}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ overflow: 'hidden' }}
        >
            <div style={modalStyle} className={classes.paper}>
                <div className="flex-apart">
                    <h2 style={{
                        marginLeft: "auto",
                        marginRight: "auto", 
                        fontSize: '95%',
                        paddingTop: '8px'
                    }} id="simple-modal-title">{modalTitle}</h2>
                    <i onClick={closeModal} 
                       style={{ padding: ".3125em", position: 'absolute', right: '8px', top: '8px' }} 
                       className="fa fa-times x-button" 
                       aria-hidden="true"></i>
                </div>
                <NewUserFormContainer 
                    closeModal={closeModal}
                    currentRole={currentRole} 
                    modifyRole={modifyRole}
                    setUserCreated={setUserCreated}
                />
            </div>
        </Modal>
    );
}
